<div>
  <table mat-table aria-label="Listagem de solicitações concluídas" [dataSource]="dataSource | paginate: { id: 'server', itemsPerPage: paginator.limit, currentPage: paginator.currentPage, totalItems: paginator.total }" class="mat-elevation-z8">
    <!-- Type document Column -->
    <ng-container matColumnDef="DocumentTitle">
      <th mat-header-cell *matHeaderCellDef> Título do documento </th>
      <td mat-cell *matCellDef="let element"> {{element.DocumentTitle}} </td>
    </ng-container>

    <!-- Name Column -->
    <ng-container matColumnDef="EmployeeName">
      <th mat-header-cell *matHeaderCellDef> Colaborador(a) </th>
      <td mat-cell *matCellDef="let element"> {{element.EmployeeName}} </td>
    </ng-container>

    <!-- CPF Column -->
    <ng-container matColumnDef="EmployeeIdentificator">
      <th mat-header-cell *matHeaderCellDef> CPF </th>
      <td mat-cell *matCellDef="let element"> {{element.EmployeeIdentificator}} </td>
    </ng-container>

    <!-- Registration Column -->
    <ng-container matColumnDef="EmployeeCode">
      <th mat-header-cell *matHeaderCellDef> Matrícula </th>
      <td mat-cell *matCellDef="let element"> {{element.EmployeeCode}} </td>
    </ng-container>

    <!-- Request Date Column -->
    <ng-container matColumnDef="RequestedAt">
      <th mat-header-cell *matHeaderCellDef> Data de solicitação </th>
      <td mat-cell *matCellDef="let element"> {{element.RequestedAt | date: 'dd/MM/yyyy'}} </td>
    </ng-container>

    <!-- Status Column -->
    <ng-container matColumnDef="Status">
      <ng-container *ngIf="concluded">
        <th mat-header-cell *matHeaderCellDef> Status </th>
        <td mat-cell *matCellDef="let element">
          <span class="list-status-label --concluded">
            <mat-icon svgIcon="check_icon" aria-hidden="false" aria-label="Ícone de check"></mat-icon>
            Concluído
          </span>
        </td>
      </ng-container>
      <ng-container *ngIf="pending">
        <th mat-header-cell *matHeaderCellDef> Status </th>
        <td mat-cell *matCellDef="let element">
          <span class="list-status-label --pending">
            <mat-icon svgIcon="clock_icon" aria-hidden="false" aria-label="Ícone de relógio"></mat-icon>
            Pendente
          </span>
        </td>
      </ng-container>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
</div>
